import { motion } from "framer-motion";
import { EASE } from "./data";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children }) => (
  <p className="mb-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">
    <span className="text-[var(--signal)]">{index}</span>
    <span className="h-px w-10 bg-[var(--line)]" />
    {children}
  </p>
);
